export const controls = {
  selectable: false,
  moveCursor: false,
  hoverCursor: "default",
  hasControls: false,
}

export const baseImgOpts = {
  left: 0,
  top: 0,
  crossOrigin: "anonymous",
}
export const logoBaseOpts = {
  ...controls,
  width: 1000,
  height: 1200,
}

export const placeholderBaseOpts = {
  ...controls,
  width: 1000,
  height: 1200,
  fill: "rgba(80, 186, 231, 0.66)",
  strokeWidth: 6,
  stroke: "#4FB9E7",
}

export const layerBase = {
  left: 0,
  top: 0,
  scaleX: 0.25,
  scaleY: 0.25,
}

export const CANVAS_SIZE = 750
export const CANVAS_CONFIG = {
  width: CANVAS_SIZE,
  height: CANVAS_SIZE,
  preserveObjectStacking: true,
  controlsAboveOverlay: true,
  selection: false,
  hasControls: false,
  moveCursor: false,
  backgroundVpt: true,
}

export const TEXT_SCALE = 4
